module.exports = __webpack_public_path__ + "static/media/add.baffc7be.svg";